module.exports = __webpack_public_path__ + "4.3.2/img/01D.537a8bb8.png";